import React from "react";
import { StaffFrame, AdminView, PageHead } from "./DashboardShared";
import { useShowToast } from "../components/Notify";

export default function AdminPage() {
  const showToast = useShowToast();

  return (
    <StaffFrame>
      <div className="page">
        <PageHead title="Vue d'ensemble" sub="Tableau de bord complet SETRAG" />
        <AdminView activePage="overview" showToast={showToast} />
      </div>
    </StaffFrame>
  );
}
